const adminLevelsTypes = {
  FETCH_ADMIN_LEVELS_REQUEST: 'SAF_APPLY_FETCH_ADMIN_LEVELS_REQUEST',
  FETCH_ADMIN_LEVELS_SUCCESS: 'SAF_APPLY_FETCH_ADMIN_LEVELS_SUCCESS',
  FETCH_ADMIN_LEVELS_FAILURE: 'SAF_APPLY_FETCH_ADMIN_LEVELS_FAILURE',

  FETCH_ADMIN_LEVEL_ITEMS_REQUEST: 'SAF_APPLY_FETCH_ADMIN_LEVEL_ITEMS_REQUEST',
  FETCH_ADMIN_LEVEL_ITEMS_SUCCESS: 'SAF_APPLY_FETCH_ADMIN_LEVEL_ITEMS_SUCCESS',
  FETCH_ADMIN_LEVEL_ITEMS_FAILURE: 'SAF_APPLY_FETCH_ADMIN_LEVEL_ITEMS_FAILURE',

  ADD_NEW_ADMIN_LEVELS_REQUEST: 'ADD_NEW_ADMIN_LEVELS_REQUEST',
  ADD_NEW_ADMIN_LEVELS_SUCCESS: 'ADD_NEW_ADMIN_LEVELS_SUCCESS',
  ADD_NEW_ADMIN_LEVELS_FAILURE: 'ADD_NEW_ADMIN_LEVELS_FAILURE',

  DELETE_ADMIN_LEVEL_REQUEST: 'DELETE_ADMIN_LEVEL_REQUEST',
  DELETE_ADMIN_LEVEL_SUCCESS: 'DELETE_ADMIN_LEVEL_SUCCESS',
  DELETE_ADMIN_LEVEL_FAILURE: 'DELETE_ADMIN_LEVEL_FAILURE',

  UPDATE_ADMIN_LEVEL_REQUEST: 'UPDATE_ADMIN_LEVEL_REQUEST',
  UPDATE_ADMIN_LEVEL_SUCCESS: 'UPDATE_ADMIN_LEVEL_SUCCESS',
  UPDATE_ADMIN_LEVEL_FAILURE: 'UPDATE_ADMIN_LEVEL_FAILURE',

  ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_REQUEST:
    'SAF_APPLY_ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_REQUEST',
  ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_SUCCESS:
    'SAF_APPLY_ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_SUCCESS',
  ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_FAILURE:
    'SAF_APPLY_ADD_NEW_ADMIN_LEVEL_ITEMS_DATA_FAILURE',

  DELETE_ADMIN_LEVEL_ITEMS_DATA_REQUEST:
    'SAF_APPLY_DELETE_ADMIN_LEVEL_ITEMS_DATA_REQUEST',
  DELETE_ADMIN_LEVEL_ITEMS_DATA_SUCCESS:
    'SAF_APPLY_DELETE_ADMIN_LEVEL_ITEMS_DATA_SUCCESS',
  DELETE_ADMIN_LEVEL_ITEMS_DATA_FAILURE:
    'SAF_APPLY_DELETE_ADMIN_LEVEL_ITEMS_DATA_FAILURE',

  UPDATE_ADMIN_LEVEL_ITEMS_DATA_REQUEST:
    'SAF_APPLY_UPDATE_ADMIN_LEVEL_ITEMS_DATA_REQUEST',
  UPDATE_ADMIN_LEVEL_ITEMS_DATA_SUCCESS:
    'SAF_APPLY_UPDATE_ADMIN_LEVEL_ITEMS_DATA_SUCCESS',
  UPDATE_ADMIN_LEVEL_ITEMS_DATA_FAILURE:
    'SAF_APPLY_UPDATE_ADMIN_LEVEL_ITEMS_DATA_FAILURE',
};

export default adminLevelsTypes;
